module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEJSURBVEhLzZUxCsJAEEVTWainEARvIYnaWdjkMpYW6gFEd1tLKwtB8QyyEbGxEQTvoNjojE5gtdgvyIAPpkhe/iTsbnajvyCx2TwxrpvO9gW59QbyQSicUt25YuMOycS1RD1BPkjbboqxyU55g2cZtxINPSQxWd8Px9ZdmxNXFQ19EH6QA34DajgQDT0kttnSD/NQtKbbkmjog1Cg44elUtHQB3lNnDv6YfratWjoITSOPT9M17e63dREQx+kMd5VKHDxG9BEDkVDD6E1vPgIn+ujfVk09BD1F6gPEUMN9CaZUV+mDIX0frQctBUgD1Hf7BgK6G3XDDpQkP8KCukdmTkU1jv0fyOKHoM4Vjf0KRnHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-two-arrows.png
// module id = 725
// module chunks = 0